/**
 * Canonical analytics names for SaaS product flows (non-marketing surfaces).
 */

export const SAAS_PRODUCT_EVENTS = {
	earlyAccessInviteClaimStarted: "early_access_invite_claim_started",
	earlyAccessInviteClaimSucceeded: "early_access_invite_claim_succeeded",
	earlyAccessInviteClaimFailed: "early_access_invite_claim_failed",
	inventoryApplyScroll: "inventory_apply_scroll",

	authSignupOutcome: "auth_signup_outcome",
	authLoginOutcome: "auth_login_outcome",
	authTwoFactorOutcome: "auth_two_factor_outcome",
	authOauthStarted: "auth_oauth_started",
	authSessionEstablished: "auth_session_established",
	authPasswordResetOutcome: "auth_password_reset_outcome",

	scenarioSuccessShown: "scenario_success_shown",
	scenarioRewardsClaimed: "scenario_rewards_claimed",
	scenarioRewardsAbandoned: "scenario_rewards_abandoned",

	/** P13 P2 — once engage binding leaf completed. */
	icBindingCompleted: "ic_binding_completed",
	/** P13 P4 — learner restart overlay scope (node | stage | attempt). */
	icRestartScope: "ic_restart_scope",
	/** P13 P5 — soft-park / reentry / abandon / exit. */
	icGraphRunParked: "ic_graph_run_parked",
	icGraphRunResumed: "ic_graph_run_resumed",
	icGraphRunAbandoned: "ic_graph_run_abandoned",
	icAttemptExitToMap: "ic_attempt_exit_to_map",
	icReentrySubmitExpired: "ic_reentry_submit_expired",
	/** InteractionTranscript — learner opened/switched a thread. */
	icTranscriptThreadOpened: "ic_transcript_thread_opened",
	/** CONVERSATION live — brief shown / begun / ended. */
	icConversationBriefShown: "ic_conversation_brief_shown",
	icConversationBegun: "ic_conversation_begun",
	icConversationEnded: "ic_conversation_ended",
	/** DECISION — learner submitted a QuizAnswerTile choice. */
	icGraphDecisionSubmitted: "ic_graph_decision_submitted",
	/** RESPONSE — classify advanced or NO_MATCH retry. */
	icGraphResponseSubmitted: "ic_graph_response_submitted",
	icGraphResponseRetry: "ic_graph_response_retry",

	/** Org Hub — shell ready once per entry. */
	hubOpened: "hub_opened",
	/** Org Hub — NPC engage from chat rail / scene. */
	hubNpcEngaged: "hub_npc_engaged",
	/** Org Hub — portal navigation to Learn (P4b). */
	hubPortalNavigated: "hub_portal_navigated",
} as const;
